// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "styles/" + "styles" + "." + "bd6b9221eb71ab11c972" + ".bundle.css";
};